import { html, render } from 'lit-html'
import store from '@polleverywhere/redux'
import { slice, LoadingState } from '@polleverywhere/redux/slices/participant_response_history'

import '@polleverywhere/pec-participant-response-history'
import '@polleverywhere/advisory-message'

import '../../components/layout_tab_bar'
import '../../components/layout_content'
import '../../components/section_header'

import './style.scss'

export default class ResponseHistory extends Backbone.View {
  get className () {
    return 'pollev-response-history'
  }

  initialize (options = {}) {
    this.unsubscribe = store.subscribe(() => {
      const state = store.getState()[slice.name]
      const prev = this.lastRenderState || {}

      const focusChanged = prev.focus !== state.focus
      const countChanged = prev.totalCount !== state.meta.total_count
      const loadingAndWasEmpty = state.loading !== prev.loading && !prev.totalCount

      if (focusChanged || countChanged || loadingAndWasEmpty) {
        this.render()
      }
    })
  }

  render () {
    const state = store.getState()[slice.name]
    const isFocussed = !!state.focus
    const isLoaded = state.loading === LoadingState.done
    const isLoadedAndEmpty = isLoaded && !isFocussed && !state.meta.total_count
    const title = isFocussed ? 'Response detail' : 'Response history'
    const subTitle = isFocussed ? '' : `${state.meta.total_count} responses`
    const action = isFocussed ? 'go-back' : 'update'

    this.lastRenderState = {
      focus: state.focus,
      loading: state.loading,
      totalCount: state.meta.total_count
    }

    render(
      html`
        <layout-tab-bar active='history' profile='participant' @change:active=${(e) => this.trigger('navigate', e.detail.route)}>
          <main slot="content">
            <section-header
              title='${title}'
              subtitle='${subTitle}'
              secondary-controls='${action}'
              level='1'
              icon-type='glyph'
              icon-name='response-history'
              @click:update=${() => store.dispatch(slice.fetchResponses())}
              @click:go-back=${() => {
                store.dispatch(slice.focusCleared())
                if (!state.meta.total_count) {
                  store.dispatch(slice.fetchResponses())
                }
              }}
            ></section-header>
            ${isLoadedAndEmpty
              ? html`<advisory-message
                  icon='info'
                  subject="You've not responded to any activites yet"
                  resolutionLabel='Update'
                  @resolve=${() => store.dispatch(slice.fetchResponses())}
                ></advisory-message>`
              : html`<pec-participant-response-history skip-header></pec-participant-response-history>`
            }
        </main>
        </layout-tab-bar>
      `, this.el, {
        eventContext: this
      }
    )

    return this
  }

  remove () {
    super.remove()
    this.unsubscribe()
  }
}
